import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import {useHistory} from 'modules/navigation/useRouter'
import React from 'react'
import {useLocation} from 'react-router-dom'
import {branch, compose} from 'recompose'
import {ContentNotFound} from 'views/AppLocals/ContentNotFound'
import {bindQueryParams,} from 'views/AppLocals/functions/routerHelper'
import {catholicHousehold_getCatholicHouseholdStats_Api} from "../../../../apis/catholicHousehold";
import {staticPaths} from "../../../../routes/staticPaths";
import {InsightsBlockHeader} from "../../Insights/WorkspaceInsights";
import useAsync from "../../../../modules/asyncCache/useAsync";
import LoadingBlock from "../../../LoadingBlock";


const CatholicHouseholdStatistics = ({
                                         owner_id,
                                         owner_type,
                                     }) => {
    const t = useTranslate()
    const history = useHistory()
    const location = useLocation()
    const apiInfo = catholicHousehold_getCatholicHouseholdStats_Api;

    const {response, isLoading} = useAsync({
        cacheId: [
            apiInfo.path
                .replace(':type', owner_type)
                .replace(':id', owner_id),
            JSON.stringify({}),
        ].join('/'),
        apiInfo,
        values: {},
        // deps: [{}],
        query: bindQueryParams([{type: owner_type}, {id: owner_id}]),
    })

    const item = _.get(response, 'data', {})

    if (isLoading) {
        return (
            <LoadingBlock/>
        )
    }

    return (
        <div className="flex flex-col gap-3">
            <InsightsBlockHeader title={t('overview')}/>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                <div
                    onClick={() => (
                        history.push(staticPaths.workspace.pathname + '/households?rel=catholic-households')
                    )}
                    className="flex flex-col flex-center px-3 py-5 custom-render-border rounded-lg cursor-pointer">
                  <span className="text-sm text-color-400 tracking-wider uppercase">
                      {t('having')}
                  </span>
                    <span className="font-semibold text-2xl text-color-100">
                      {item?.total?.households}
                  </span>
                </div>
                <div
                    onClick={() => (
                        history.push(staticPaths.workspace.pathname + '/households?rel=pending-catholic-households')
                    )}
                    className="flex flex-col flex-center px-3 py-5 custom-render-border rounded-lg cursor-pointer">
                  <span className="text-sm text-color-400 tracking-wider uppercase">
                      {t('pending')}
                  </span>
                    <span className="font-semibold text-2xl text-color-100">
                      {item?.total?.pending}
                  </span>
                </div>
                <div
                    onClick={() => (
                        history.push(staticPaths.workspace.pathname + '/households?rel=catholic-households&status=-2')
                    )}
                    className="flex flex-col flex-center px-3 py-5 custom-render-border rounded-lg cursor-pointer">
                  <span className="text-sm text-color-400 tracking-wider uppercase">
                      {t('reject')}
                  </span>
                    <span className="font-semibold text-2xl text-color-100">
                      {item?.total?.rejected}
                  </span>
                </div>
            </div>
        </div>
    )
}


export default compose(
    branch(
        ({owner_id, owner_type}) => _.some([owner_id, owner_type], _.isEmpty),
        () => () => <ContentNotFound/>
    )
)(CatholicHouseholdStatistics)
